import { Scale } from "lucide-react";

export const POLICY_SUMMARY =
  "Hosts may accept or decline a request only based on the guest's stay history, reviews from other hosts, dates, group size and house rules. Never based on race, color, ethnicity, national origin, religion, sex, gender identity, sexual orientation, disability, age, marital or family status.";

const RULES = [
  "Decisions must be based only on what FairStay shows you: past stays, reviews from other hosts, complaint history, dates, group size and your house rules.",
  "You may not decline, cancel, charge more, or set different rules for anyone because of race, color, ethnicity, national origin, religion, sex, gender identity or expression, sexual orientation, disability, age, marital status or family status.",
  "You may not use a guest's name or profile photo to guess any of these traits or as a reason to decline.",
  "Every decline needs a reason from the list we provide. FairStay reviews decline patterns.",
  "Hosts who break this policy can be suspended or removed from FairStay.",
];

export default function NonDiscrimination() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6" data-testid="nondiscrimination-page">
      <Scale className="mb-4 h-9 w-9 text-primary" />
      <h1 className="text-4xl font-bold tracking-tight">Non-discrimination policy</h1>
      <p className="mt-4 text-stone-700">FairStay is open to everyone. Hosts decide on requests only from a guest's track record on FairStay, not from who the guest is.</p>
      <ol className="mt-8 space-y-4">
        {RULES.map((r, i) => (
          <li key={r.slice(0, 40)} className="flex gap-4 rounded-2xl border bg-white p-5 text-sm leading-relaxed text-stone-700">
            <span className="font-mono-num font-semibold text-primary">{i + 1}</span>{r}
          </li>
        ))}
      </ol>
      <p className="mt-8 text-sm text-stone-500">If you think a host treated you unfairly, report it on your trip and our team will review it.</p>
    </div>
  );
}
